import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie Policy — Comm42" },
      { name: "description", content: "Informativa sull'uso dei cookie sul sito Comm42 SA." },
      { property: "og:title", content: "Cookie Policy — Comm42" },
      { property: "og:description", content: "Informativa sull'uso dei cookie sul sito Comm42 SA." },
      { property: "og:url", content: "https://comm42.ch/cookies" },
    ],
    links: [{ rel: "canonical", href: "https://comm42.ch/cookies" }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <PageShell>
      <PageHero eyebrow="LEGALE" title="Cookie Policy" subtitle="Informazioni sui cookie e tecnologie simili utilizzati su questo sito." />
      <section className="mx-auto max-w-3xl px-6 py-16 prose prose-invert prose-headings:font-serif prose-a:text-primary">
        <h2>Cosa sono i cookie</h2>
        <p>I cookie sono piccoli file di testo che i siti visitati salvano sul dispositivo dell'utente per memorizzare informazioni utili al funzionamento del sito o a migliorare l'esperienza di navigazione.</p>

        <h2>Cookie utilizzati da questo sito</h2>
        <ul>
          <li><strong>Cookie tecnici / di sessione</strong> — necessari al corretto funzionamento del sito (es. preferenze di lingua, autenticazione nell'area riservata). Non richiedono consenso.</li>
          <li><strong>Cookie di terze parti</strong> — possono essere impostati da servizi esterni eventualmente integrati (es. mappe, video). Si rimanda alle rispettive informative.</li>
        </ul>
        <p>Questo sito <strong>non utilizza cookie di profilazione o pubblicitari</strong>.</p>

        <h2>Gestione dei cookie</h2>
        <p>L'utente può in qualsiasi momento modificare le preferenze sui cookie tramite le impostazioni del proprio browser (Chrome, Firefox, Safari, Edge). La disattivazione dei cookie tecnici può compromettere alcune funzionalità del sito.</p>

        <h2>Contatti</h2>
        <p>Per qualsiasi richiesta relativa all'uso dei cookie scrivere a <a href="mailto:administration@comm42.eu">administration@comm42.eu</a>.</p>
      </section>
    </PageShell>
  );
}